<template>
  <div>
    <div class="tabs hidden-print">
      <ul v-sticky sticky-offset="offset">
        <router-link
          v-slot="{ href, navigate, isActive }"
          :to="{ name: 'marketing.giftActions.giftActions.list' }"
          custom
        >
          <li :class="[isActive && 'router-link-active is-active']" role="link">
            <a :href="href" @keypress.enter="navigate" @click="navigate">
              Δώρα
            </a>
          </li>
        </router-link>
        <router-link
          v-slot="{ href, navigate, isActive }"
          :to="{ name: 'marketing.giftActions.banners' }"
          custom
        >
          <li :class="[isActive && 'router-link-active is-active']" role="link">
            <a :href="href" @keypress.enter="navigate" @click="navigate">
              Banners
            </a>
          </li>
        </router-link>
      </ul>
    </div>
    <RouterView />
  </div>
</template>

<script>
export default {
  data() {
    return {
      offset: { top: 45 },
    };
  },
};
</script>
